import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled, { keyframes } from "styled-components";

const Container = styled.div`
  background-color: var(--primary-200);
  width: 100%;
  max-width: 100vw;
  height: var(--navbar-mini);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Wrapper = styled.header`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    max-width: var(--max-width-container);
    padding: 0;
    display: grid; /* Prikazuje sve elemente odjednom na širim ekranima */
    grid-template-columns: repeat(3, 1fr);
    gap: 2px;
  }
`;
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(2px); }
  to { opacity: 1; transform: translateY(0); }
`;
const GridItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: var(--bg-100);
  font-size: var(--font-size-small);
  font-weight: 500;
  letter-spacing: 0.2px;
  animation: ${fadeIn} 0.4s ease;

  svg {
    flex-shrink: 0;
  }
`;

const HeaderSlider = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const sliderItems = [
    { id: 1, text: t("HEADER_SLIDER.DELIVERY_TO_AUSTRIA") },
    { id: 2, text: t("HEADER_SLIDER.BIG_SELECTION") },
    { id: 3, text: t("HEADER_SLIDER.BEST_CUSTOMER_SERVICE") },
  ];

  // Provera da li je ekran mobilni ili desktop
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Menja slajd svakih 5 sekundi samo na mobilnom
  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === sliderItems.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);
      return () => clearInterval(interval); // Očisti interval na unmount
    }
  }, [isMobile]);

  const CheckIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12.5L9.5 18L20 6"
        stroke="var(--bg-100)"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <Container>
      <Wrapper>
        {isMobile ? (
          <GridItem key={currentIndex}>
            <CheckIcon />
            {sliderItems[currentIndex].text}
          </GridItem>
        ) : (
          sliderItems.map((item) => (
            <GridItem key={item.id}>
              <CheckIcon />
              {item.text}
            </GridItem>
          ))
        )}
      </Wrapper>
    </Container>
  );
};

export default HeaderSlider;
